/**
 * Validation utilities for share codes and PINs
 */

// Share code: 6 characters, uppercase letters and digits only
const SHARE_CODE_REGEX = /^[A-Z0-9]{6}$/;

// PIN: 4 characters, uppercase letters and digits only
const PIN_REGEX = /^[A-Z0-9]{4}$/;

export function isValidShareCode(code: string | undefined): boolean {
  if (!code) return false;
  return SHARE_CODE_REGEX.test(code);
}

export function isValidPin(pin: string | undefined): boolean {
  if (!pin) return false;
  return PIN_REGEX.test(pin);
}

export function generatePin(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  return Array.from({ length: 4 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
}

export function formatCodeInput(input: string): string {
  // Remove non-alphanumeric characters and convert to uppercase
  return input.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}
